import React from "react";
import './swipeable_container.scss';

let touchInfo = {
    direction: "none",
    swipeType: "",
    startX: "",
    startY: "",
    distX: "",
    distY: "",
    elapsedTime: "",
    startTime: "",
    isMouseDown: false
};
export class SwipeableContainer extends React.Component {
    constructor(props) {
        super(props);
        this.onTouchEnd = this.onTouchEnd.bind(this);
        this.onTouchStart = this.onTouchStart.bind(this);
        this.onTouchMove = this.onTouchMove.bind(this);
        this.onMouseDown = this.onMouseDown.bind(this);
        this.onMouseMove = this.onMouseMove.bind(this);
        this.onMouseUp = this.onMouseUp.bind(this);
    }
    onTouchStart = (e) => {
        e.preventDefault();
        const touchobj = e.changedTouches[0];
        touchInfo = {
            ...touchInfo,
            direction: "none",
            swipeType: "none",
            distX: 0,
            distY: 0,
            startX: touchobj.pageX,
            startY: touchobj.pageY,
            startTime: new Date().getTime()
        };
        if (this.props.handleTouch)
            this.props.handleTouch(e, "none", "start", touchInfo.swipeType, 0);
    };
    onTouchMove = (e) => {
        e.preventDefault(); // prevents scrolling.
        const touchobj = e.changedTouches[0];
        touchInfo.distX = touchobj.pageX - touchInfo.startX;
        touchInfo.distY = touchobj.pageY - touchInfo.startY;

        if (Math.abs(touchInfo.distX) > Math.abs(touchInfo.distY)) {
            // if distance traveled horizontally is greater than vertically, consider this a horizontal movement
            touchInfo.direction = touchInfo.distX < 0 ? "left" : "right";
            if (this.props.handleTouch)
                this.props.handleTouch(
                    e,
                    touchInfo.direction,
                    "move",
                    touchInfo.swipeType,
                    touchInfo.distX
                );
        } else {
            // else consider this a vertical movement
            touchInfo.direction = touchInfo.distY < 0 ? "up" : "down";
            if (this.props.handleTouch)
                this.props.handleTouch(
                    e,
                    touchInfo.direction,
                    "move",
                    touchInfo.swipeType,
                    touchInfo.distY
                );
        }
    };
    onTouchEnd = (e) => {
        e.preventDefault();

        touchInfo.elapsedTime = new Date().getTime() - touchInfo.startTime; // get time elapsed
        if (touchInfo.elapsedTime <= this.props.allowedTime || 500) {
            // first condition for swipe met
            if (
                Math.abs(touchInfo.distX) >= (this.props.threshold || 500) &&
                Math.abs(touchInfo.distY) <= (this.props.restraint || 500)
            ) {
                // 2nd condition for horizontal swipe met
                touchInfo.swipeType = touchInfo.direction; // set swipeType to either "left" or "right"
            } else if (
                Math.abs(touchInfo.distY) >= (this.props.threshold || 500) &&
                Math.abs(touchInfo.distX) <= (this.props.restraint || 500)
            ) {
                // 2nd condition for vertical swipe met
                touchInfo.swipeType = touchInfo.direction; // set swipeType to either "top" or "down"
            }
        }

        if (this.props.handleTouch)
            this.props.handleTouch(
                e,
                touchInfo.direction,
                "end",
                touchInfo.swipeType,
                touchInfo.direction === "left" || touchInfo.direction === "right"
                    ? touchInfo.distX
                    : touchInfo.distY
            );
    };
    onMouseDown = (e) => {
        e.preventDefault();
        const touchobj = e;
        touchInfo = {
            ...touchInfo,
            isMouseDown: true,
            direction: "none",
            swipeType: "none",
            distX: 0,
            startX: touchobj.pageX,
            startY: touchobj.pageY,
            startTime: new Date().getTime()
        };
        if (this.props.handleTouch)
            this.props.handleTouch(e, "none", "start", touchInfo.swipeType, 0);
    };
    componentDidMount() {
        document.body.addEventListener("mousemove", this.onMouseMove, false);
        document.body.addEventListener("mouseup", this.onMouseUp, false);
    }
    componentWillUnmount() {
        document.body.removeEventListener("mousemove", this.onMouseMove, false);
        document.body.removeEventListener("mouseup", this.onMouseUp, false);
    }
    onMouseMove = (e) => {
        e.preventDefault();
        if (touchInfo.isMouseDown) {
            var touchobj = e;
            touchInfo.distX = touchobj.pageX - touchInfo.startX; // get horizontal dist traveled by finger while in contact with surface
            touchInfo.distY = touchobj.pageY - touchInfo.startY; // get vertical dist traveled by finger while in contact with surface
            if (Math.abs(touchInfo.distX) > Math.abs(touchInfo.distY)) {
                // if distance traveled horizontally is greater than vertically, consider this a horizontal movement
                touchInfo.direction = touchInfo.distX < 0 ? "left" : "right";
                if (this.props.handleTouch)
                    this.props.handleTouch(
                        e,
                        touchInfo.direction,
                        "move",
                        touchInfo.swipeType,
                        touchInfo.distX
                    );
            } else {
                // else consider this a vertical movement
                touchInfo.direction = touchInfo.distY < 0 ? "up" : "down";
                this.props.handleTouch(
                    e,
                    touchInfo.direction,
                    "move",
                    touchInfo.swipeType,
                    touchInfo.distY
                );
            }
        }
    };
    onMouseUp = (e) => {
        e.preventDefault();
        if (touchInfo.isMouseDown) {
            touchInfo.elapsedTime = new Date().getTime() - touchInfo.startTime; // get time elapsed
            if (touchInfo.elapsedTime <= (this.props.allowedTime || 500)) {
                // first condition for swipe met
                if (
                    Math.abs(touchInfo.distX) >= (this.props.threshold || 500) &&
                    Math.abs(touchInfo.distY) <= (this.props.restraint || 500)
                ) {
                    // 2nd condition for horizontal swipe met
                    touchInfo.swipeType = touchInfo.direction; // set swipeType to either "left" or "right"
                } else if (
                    Math.abs(touchInfo.distY) >= (this.props.threshold || 500) &&
                    Math.abs(touchInfo.distX) <= (this.props.restraint || 500)
                ) {
                    // 2nd condition for vertical swipe met
                    touchInfo.swipeType = touchInfo.direction; // set swipeType to either "top" or "down"
                }
            }

            if (this.props.handleTouch)
                this.props.handleTouch(
                    e,
                    touchInfo.direction,
                    "end",
                    touchInfo.swipeType,
                    touchInfo.direction === "left" || touchInfo.direction === "right"
                        ? touchInfo.distX
                        : touchInfo.distY
                );
            touchInfo.isMouseDown = false;
        }
    };
    render() {
        return (
            <div
                onTouchStart={this.onTouchStart}
                onTouchMove={this.onTouchMove}
                onTouchEnd={this.onTouchEnd}
                onMouseDown={this.onMouseDown}
                className={`swipeable-drawer ${this.props.className ? this.props.className : ''}`}
            >
                <div className="drawer"/>
                {this.props.children}
            </div>
        );
    }
}
